import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface FacebookPixelProps {
  pixelId: string | null;
}

declare global {
  interface Window {
    fbq: (
      action: string,
      eventName: string,
      params?: Record<string, any>,
      options?: { eventID?: string }
    ) => void;
    _fbq: typeof window.fbq;
  }
}

const FacebookPixel: React.FC<FacebookPixelProps> = ({ pixelId }) => {
  const location = useLocation();

  useEffect(() => {
    if (!pixelId) return;

    // Initialize Facebook Pixel
    if (!window.fbq) {
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );
    }

    // Initialize pixel
    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
  }, [pixelId]);

  // Track page views on route change
  useEffect(() => {
    if (!pixelId || !window.fbq) return;

    window.fbq("track", "PageView");
  }, [location.pathname, pixelId]);

  return null;
};

export default FacebookPixel;

